<template>
  <PromotionTrackingWrapper v-if="banner" :position="position" :content="banner">
    <LinkWrapper :link-url="banner.fields.linkUrl" :is-external-link="banner.fields.isExternalLink">
      <ContentfulImage
        class="w-full mx-auto rounded shadow-md"
        :entry="mq.xsmall ? banner.fields.bannerMobile : banner.fields.bannerDesktop"
        :width="mq.xsmall ? 736 : 1740"
        :height="mq.xsmall ? 368 : 348"
        fit="fill"
      />
    </LinkWrapper>
  </PromotionTrackingWrapper>
</template>

<script setup lang="ts">
import { Banner } from '@/types/content';

type Props = {
  content?: Record<string, any>;
  position?: string;
};

const { content, position } = withDefaults(defineProps<Props>(), {
  content: () => {},
  position: '',
});
const { mq } = useMediaQueries();
const route = useRoute();

const banner = ref<Banner | null>(null);

onMounted(() => {
  setRandomMarketingBanner();
});

watch(route, () => {
  setRandomMarketingBanner();
});

const setRandomMarketingBanner = () => {
  const banners = content?.fields?.banners;
  if (!banners?.length) return;

  const totalWeight = banners
    .map((banner: any) => banner.fields.weight)
    .reduce((total: number, cur: number) => total + cur);
  const randomNumber = Math.random() * totalWeight;
  let currentWeight = 0;
  for (let i = 0; i <= banners.length - 1; ++i) {
    currentWeight += banners[i].fields.weight;

    if (currentWeight >= randomNumber) {
      banner.value = { ...banners[i] };
      break;
    }
  }
};
</script>
<script lang="ts">
export default defineComponent({
  name: 'MarketingBanners',
});
</script>
